import {IntlShape} from "react-intl";
import {TipPrice} from "./paymentApi";

export function formatMoney(money: TipPrice, intl: IntlShape): string {
    return `${money.amount}\u00A0${intl.formatMessage({id: money.ccy.toLowerCase()})}`;
}
